
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.251 17.063h-4.5c-2.078 0-3.485-.44-4.429-1.384S.938 13.328.938 11.251v-4.5c0-2.078.44-3.486 1.384-4.429S4.673.938 6.751.938h4.5c2.078 0 3.485.44 4.429 1.384s1.384 2.351 1.384 4.429v4.5c0 2.078-.44 3.485-1.384 4.429s-2.352 1.383-4.429 1.383zm-4.5-15c-1.763 0-2.915.335-3.634 1.054S2.063 4.988 2.063 6.751v4.5c0 1.76.335 2.914 1.054 3.634s1.871 1.053 3.634 1.053h4.5c1.76 0 2.914-.335 3.634-1.054s1.054-1.874 1.054-3.634v-4.5c0-1.76-.335-2.914-1.054-3.634s-1.875-1.053-3.634-1.053z","fill":"#697485"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.751 3.938a2.063 2.063 0 11-2.063 2.063 2.065 2.065 0 012.063-2.063zm0 3a.938.938 0 10-.937-.937.939.939 0 00.937.937zM2.003 14.775a.562.562 0 01-.468-.249.562.562 0 01.155-.781l3.7-2.482a2.264 2.264 0 012.66.145l.245.215a1.11 1.11 0 001.38 0l3.12-2.678a2.228 2.228 0 012.848 0l1.223 1.053a.563.563 0 11-.733.853l-1.222-1.05a1.11 1.11 0 00-1.382 0l-3.12 2.678a2.228 2.228 0 01-2.848 0l-.245-.215a1.122 1.122 0 00-1.3-.063l-3.7 2.478a.56.56 0 01-.313.096z","fill":"#697485","opacity":".4"}})])
          )
        }
      }
    